import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msalConfig';
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./components/ui/theme-provider";
import { Toaster } from "./components/ui/toaster";
import ProtectedRoute from "./components/ProtectedRoute";
import ConsultorRoute from "./components/ConsultorRoute";
import HomologBanner from "./components/HomologBanner";
import Login from "./pages/Login";
import TypeformDashboard from "./pages/TypeformDashboard";
import AcompanhamentoSemanal from "./pages/AcompanhamentoSemanal";
import ClientesProdutos from "./pages/ClientesProdutos";
import UploadPatrimonio from "./pages/UploadPatrimonio";
import LeadsAplicacao from "./pages/LeadsAplicacao";
import MinhaSemana from "./pages/MinhaSemana";

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        {/* defaultTheme="light": o shell do dashboard é claro (hardcoded); "system" deixava
            as abas Pipeline/Projetos escuras dentro de chrome branco em OS dark. */}
        <ThemeProvider defaultTheme="light" storageKey="consultant-ui-theme">
          <AuthProvider>
            <div className="App font-sans" style={process.env.REACT_APP_ENV === 'homolog' ? { paddingTop: 'var(--care-space-9)' } : {}}>
              <HomologBanner />
              <BrowserRouter>
                <Routes>
                  {/* Login */}
                  <Route path="/login" element={<Login />} />

                  {/* Dashboard - página principal após login */}
                  <Route path="/dashboard" element={<ProtectedRoute><TypeformDashboard /></ProtectedRoute>} />

                  {/* Minha Semana - página restrita do consultor (preenche o pipeline) */}
                  <Route path="/minha-semana" element={<ConsultorRoute><MinhaSemana /></ConsultorRoute>} />

                  {/* Leads Aplicação */}
                  <Route path="/leads-aplicacao" element={<ProtectedRoute><LeadsAplicacao /></ProtectedRoute>} />

                  {/* Patrimônio Líquido - Upload */}
                  <Route path="/upload-patrimonio" element={<ProtectedRoute><UploadPatrimonio /></ProtectedRoute>} />

                  {/* Patrimônio Líquido - Acompanhamento Semanal */}
                  <Route path="/acompanhamento" element={<ProtectedRoute><AcompanhamentoSemanal /></ProtectedRoute>} />

                  {/* Patrimônio Líquido - Clientes e Produtos */}
                  <Route path="/produtos" element={<ProtectedRoute><ClientesProdutos /></ProtectedRoute>} />

                  {/* Rota inicial - redireciona para login */}
                  <Route path="/" element={<Navigate to="/login" replace />} />

                  {/* Qualquer outra rota vai pro dashboard */}
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </BrowserRouter>
              <Toaster />
            </div>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </MsalProvider>
  );
}

export default App;
